"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MOUSEMOVE = "MOUSEMOVE";
var MOUSEDOWN = "MOUSEDOWN";
var MOUSEUP = "MOUSEUP";
var MOUSEOUT = "MOUSEOUT";
var ERROR = "ERROR";
var SUCCESS = "SUCCESS";
var TIMEDOUT = "TIMEDOUT";
var ROTATE = "ROTATE";
var MOVE = "MOVE";

var ImagesLoader =
/*#__PURE__*/
function () {
	function ImagesLoader(core) {
		_classCallCheck(this, ImagesLoader);

		this.core = core;
		this.count = 0;
		this.images = [];
		this.errors = [];
		this.isAllLoaded = false;
		this.isEnded = false;
		this.loadImages();
	}

	_createClass(ImagesLoader, [{
		key: "createDOM",
		value: function createDOM() {
			var $wrapper = this.core.wrapper.imagecontent;
			var $img = $wrapper.find("img");

			for (var id = 0; id < this.images.length; id++) {
				var img = this.images[id];
				var number = id + 1;
				$wrapper.append(img);
			}

			$img.remove();
		}
	}, {
		key: "loading",
		value: function loading(id, callback, timeout) {
			var _this = this;

			var _this$core$images = this.core.images,
				filesName = _this$core$images.filesName,
				src = _this$core$images.src,
				extension = _this$core$images.extension;
			timeout = timeout || 5000;
			var timedOut = false,
				timer;
			var imgPath = src + filesName + "." + extension;
			imgPath = imgPath.replace("{$i}", id.toString());
			var img = new Image();
			img.onerror = img.onabort = function () {
				if (!timedOut) {
					clearTimeout(timer);
					callback(img, ERROR, _this);
				}
			};

			img.onload = function () {
				if (!timedOut) {
					clearTimeout(timer);
					callback(img, SUCCESS, _this);
				}
			};

			img.src = imgPath;
			img.className = "frame-" + id;

			img.ondragstart = function () {
				return false;
			};

			if (id === 1) {
			    img.style.zIndex = "1";
			} else {
			    img.style.zIndex = "0";
			}

			timer = setTimeout(function () {
				timedOut = true;
				img.src = imgPath;
				callback(img, TIMEDOUT, _this);
			}, timeout);
		}
	}, {
		key: "getstatus",
		value: function getstatus(img, stats, _this) {
			_this.count++;

			if (stats === SUCCESS) {
				_this.images.push(img);
			} else {
				_this.errors.push(img);
			}

			if (_this.count === _this.core.images.max) {
				_this.isEnded = true;
			}
		}
	}, {
		key: "loadImages",
		value: function loadImages() {
			var _this$core$images2 = this.core.images,
				min = _this$core$images2.min,
				max = _this$core$images2.max;

			for (var id = min; id <= max; id++) {
				this.loading(id, this.getstatus);
			}
		}
	}]);

	return ImagesLoader;
}();

var Module360 =
/*#__PURE__*/
function () {
	function Module360(id) {
		_classCallCheck(this, Module360);

		var $wrapper = $(id);
		this.images = {
			min: $wrapper.data("min-value"),
			max: $wrapper.data("max-value"),
			filesName: $wrapper.data("files"),
			src: $wrapper.data("src"),
			extension: $wrapper.data("extension")
		};
		this.isLoaded = false;
		this.isActive = false;
		this.drag = {
			status: false,
			type: null,
			start: {
				x: 0,
				y: 0
			}
		};
		this.currentFrame = 1;
		this.mode = ROTATE;
		this.mouse = {
			x: 0,
			y: 0
		};
		this.time = {
			fps: 13,
			interval: null,
			then: Date.now(),
			delta: null,
			now: null,
            delay : 1000
		};
		this.wrapper = {
			el: $wrapper,
			imagecontent: $wrapper.find(".image-content"),
			preloader: $wrapper.find(".preloader")
		};
		this.animation = {
			isAnimating: false,
			id: null,
			timeOut: null,
            isInfinite : false,
        };
        this.isTouch = true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
	}

	_createClass(Module360, [{
		key: "updateFrame",
        value: function updateFrame(dir) {
			var totalFrames = this.images.max;
			var $images = this.wrapper.imagecontent.find("img");
			this.currentFrame += dir;
            if (this.currentFrame < 1) this.currentFrame = totalFrames; else if (this.currentFrame > totalFrames) this.currentFrame = 1;
            if (!this.isTouch) {
                $images.css('zIndex', '0');
                $(".frame-" + this.currentFrame).css('zIndex', '1');
            } else {
                $images.hide();
                $(".frame-" + this.currentFrame).show();
            }
			
		}
	}, {
		key: "animLoop",
		value: function animLoop() {
			var _this2 = this;
			this.animation.id = window.requestAnimationFrame(function () {
				return _this2.animLoop();
			});
			this.time.now = Date.now();
			this.time.delta = this.time.now - this.time.then;
			if (this.time.delta > this.time.interval) {
				this.time.then = this.time.now - this.time.delta % this.time.interval;
				this.updateFrame(1);
			}
			if ((!this.animation.isInfinite) && (this.currentFrame == 1)) {
			    this.stop();
			}   
		}
	}, {
		key: "stop",
		value: function stop() {
			clearTimeout(this.animation.timeOut);
			if (this.animation.isAnimating === true) {
				this.animation.isAnimating = false;
				cancelAnimationFrame(this.animation.id);
			}
		}
	}, {
		key: "start",
		value: function start() {
			this.time.interval = 1000 / this.time.fps;
			if (this.animation.isAnimating === false) {
			    this.animation.isAnimating = true;
				this.animLoop();
			}
		}
	}, {
		key: "loadImages",
		value: function loadImages() {
		    var _this = this;
			var imagesLoader = new ImagesLoader(this);
			var interval = setInterval(function () {
				if (imagesLoader.isEnded) {
					
					if (imagesLoader.errors.length === 0) {
					    imagesLoader.createDOM();
                        //Rajoute un petit timeout pour éviter un flash sur chrome Mac
						setTimeout(function () {
					        _this.wrapper.preloader.fadeOut("fast");
					        _this.isLoaded = true;
					        _this.start();
					    }, 500);
					}
					clearTimeout(interval);
				}
			}, 500);
		}
	}, {
		key: "eventsListeners",
		value: function eventsListeners() {
			var _this3 = this;

			this.wrapper.el.on("mousedown touchstart", function (event) {
				event.preventDefault();
				event.stopPropagation();

				_this3.onDown(event);

				return false;
			});
		}
	}, {
		key: "selectMode",
		value: function selectMode(event) {
			var $target = $(event.currentTarget);
			var $siblings = $target.siblings();
			$siblings.removeClass("active");
			$target.addClass("active");

			if ($target.hasClass("move")) {
				this.mode = MOVE;
			} else {
				this.mode = ROTATE;
			}
		}
	}, {
		key: "init",
		value: function init() {
		    var _this = this;
			this.currentFrame = 1;
			this.isActive = true;
			if (!this.isLoaded) {
			    this.wrapper.preloader.fadeIn("fast");
			    this.loadImages();
			} else {
			    //Rajoute un petit timeout pour laisser le temps au carousel de finir son déplacement avant de lancer
			    setTimeout(function () {
			        _this.start();
			    }, 250);
			    
			}
			 
			this.eventsListeners();
		}
	}, {
		key: "destroy",
		value: function destroy() {
			this.isActive = false;
			this.stop();
			this.reset();
			this.wrapper.el.off("mousedown touchstart");
		}
	}, {
		key: "reset",
		value: function removeDOM() {
			var $images = this.wrapper.imagecontent.find("img");            
            if (!this.isTouch) {
                $images.not($(".frame-1")).css('zIndex', '0');
                $(".frame-1").css('zIndex', '1');
            } else {
                $images.not($(".frame-1")).hide();
                $(".frame-1").show();
            }
		}
	}, 
    {
		key: "onDown",
		value: function onDown(e) {
			var _this4 = this;
           
           
			this.drag.status = true;
			this.drag.type = MOUSEDOWN;
			
            if (!_this4.isTouch) {
                this.drag.start.x = e.clientX;
                this.drag.start.y = e.clientY;
            } else {

                this.drag.start.x = e.originalEvent.touches[0].clientX; 
            }
			this.stop();
			this.wrapper.el.on("mousemove touchmove", function (event) {
				event.preventDefault();
                event.stopPropagation();
                

				_this4.onMouseMove(event);

				return false;
			}).one("mouseup mouseleave touchend touchcancel", function (event) {
				event.preventDefault();
				event.stopPropagation();
				_this4.onUp(event);
				_this4.wrapper.el.off("mousemove touchmove");

				return false;
			});
		}
	}, {
		key: "onMouseMove",
		value: function onMouseMove(e) {
			
            
            if (!this.isTouch) {
				this.mouse.x = e.clientX;
				this.mouse.y = e.clientY;
			} else {
			   
			    this.mouse.x = e.originalEvent.touches[0].clientX;
			    this.mouse.y = e.originalEvent.touches[0].clientY;
			}
            
            var dx = this.mouse.x - this.drag.start.x;
            
			var abs_dx = Math.abs(dx);

            if (!this.isTouch) {
				if (abs_dx > 3) {
				    this.updateFrame(-dx / abs_dx);
				    this.drag.start.x = e.clientX;
				    this.drag.start.y = e.clientY;
				}

			} else {
				if (abs_dx > 5) {
				    this.updateFrame(-dx / abs_dx);
				    this.drag.start.x = e.originalEvent.touches[0].clientX;
				    this.drag.start.y = e.originalEvent.touches[0].clientY;
				}

			}
		}
	}, {
		key: "onUp",
		value: function onUp(e) {
			var _this5 = this;			
			clearTimeout(this.animation.timeOut);
			if (this.animation.isInfinite) {
			    this.animation.timeOut = setTimeout(function () {
			        _this5.start();
			    }, this.time.delay);
			}
			
		}
	}]);

	return Module360;
}();
